import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/categories`);
      setCategories(data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div data-testid="loading-state" className="flex items-center justify-center min-h-screen">
        <div className="text-lg text-muted-foreground">Loading...</div>
      </div>
    );
  }

  return (
    <div data-testid="categories-page" className="min-h-screen bg-background py-16">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <h1 className="font-serif text-4xl font-bold mb-12">Browse by Category</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              data-testid={`category-${category.slug}`}
              className="border border-border p-8 hover-scale smooth-transition group"
            >
              <h2 className="font-serif text-2xl font-bold group-hover:text-primary smooth-transition">
                {category.name}
              </h2>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Categories;